import { create } from 'zustand';

// Zustand store for GNSS receiver data
// This allows components to subscribe to only the data they need,
// preventing unnecessary re-renders
const useGnssStore = create((set) => ({
  // GNSS position data
  position: null,
  latitude: null,
  longitude: null,
  altitude: null,

  // Fix information
  fixQuality: 0,
  numSatellites: 0,
  hdop: null,
  ageSeconds: null,

  // Status
  loading: false,
  error: null,
  lastUpdate: null,

  // Actions
  updateGnssData: (data) => set({
    position: data.latitude && data.longitude ? {
      latitude: data.latitude,
      longitude: data.longitude,
      altitude: data.altitude
    } : null,
    latitude: data.latitude,
    longitude: data.longitude,
    altitude: data.altitude,
    fixQuality: data.fix_quality,
    numSatellites: data.num_satellites,
    hdop: data.hdop,
    ageSeconds: data.age_seconds,
    lastUpdate: Date.now(),
    error: null
  }),

  setLoading: (loading) => set({ loading }),

  setError: (error) => set({ error, loading: false }),

  clearError: () => set({ error: null }),

  // Helper to check if we have a valid fix
  hasValidFix: () => {
    const state = useGnssStore.getState();
    return state.fixQuality > 0;
  }
}));

export default useGnssStore;
